// components/Seo.js
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import React from "react";

const metaMap = {
    '/': {
        title: 'All-in-One Document Solution for Agents | Ink Agent',
        description:
            'Simplify client communications and document handling. Ink Agent lets you fill, sign, and share contracts quickly, anytime, anywhere, securely.',
        keywords: 'document signing, client management, real estate contracts, e-signature, Ink Agent',
        canonical: 'https://www.inkagent.ai/',
    },
    '/pricing-agent': {
        title: 'Transparent Pricing Plans for Agents | Ink Agent',
        description:
            'Pick the plan that grows with you. Ink Agent’s pricing gives agents powerful tools to handle contracts, client sharing, and e-signatures, all in one place.',
        keywords: 'Ink Agent pricing, real estate software pricing, e-signature plan, agent tools',
        canonical: 'https://www.inkagent.ai/pricing-agent',
    },
    '/faq': {
        title: 'Frequently Asked Questions | Ink Agent Support',
        description:
            'Got questions? Get instant clarity on features, billing, document workflows, and more. Our FAQ section helps you get the most from Ink Agent quickly.',
        keywords: 'Ink Agent FAQ, billing, support, troubleshooting, help',
        canonical: 'https://www.inkagent.ai/faq',
    },
    '/resources': {
        title: 'Free Tools & Tips for Agents | Ink Agent Resources',
        description:
            'Explore helpful guides, how-tos, and insights designed for real estate agents. Ink Agent’s resources simplify document signing, sharing, and productivity.',
        keywords: 'real estate tools, agent resources, document tips, Ink Agent',
        canonical: 'https://www.inkagent.ai/resources',
    },
    '/support': {
        title: 'Need Help? Contact Ink Agent Support Team Today',
        description:
            'Get expert help from the Ink Agent support team. Whether it’s setup, document signing, or client sharing, we’re here to keep your workflow running.',
        keywords: 'support, Ink Agent help, agent assistance, contact support',
        canonical: 'https://www.inkagent.ai/support',
    },
    '/terms-conditions': {
        title: 'Terms & Conditions for Using Ink Agent Services',
        description:
            'Get clarity on the legal use of Ink Agent. View our Terms & Conditions covering usage rules, privacy, liabilities, and your agreement as a platform user.',
        keywords: 'terms of service, Ink Agent terms, legal',
        canonical: 'https://www.inkagent.ai/terms-conditions',
    },
    '/privacy-policy': {
        title: 'Ink Agent Privacy Policy – Secure & Transparent',
        description:
            'Review our detailed privacy policy covering data collection, storage, sharing, and more. Ink Agent is dedicated to protecting your information.',
        keywords: 'privacy, data security, Ink Agent policy',
        canonical: 'https://www.inkagent.ai/privacy-policy',
    },
    '/contact-sales': {
        title: 'Connect with Ink Agent Sales Team',
        description:
            'Want to scale your business? Contact the Ink Agent sales team for tailored pricing, feature guidance, and a full platform demo designed for agents.',
        keywords: 'contact sales, Ink Agent demo, real estate sales support',
        canonical: 'https://www.inkagent.ai/contact-sales',
    },
    '/login': {
        title: 'Ink Agent Login – Access Your Agent Dashboard',
        description:
            'Log in to Ink Agent to access secure tools for document management, e‑signing, client sharing, and streamlined workflows designed for real estate pros.',
        keywords: 'login, Ink Agent login, dashboard access',
        canonical: 'https://www.inkagent.ai/login',
    },
    '/register': {
        title: 'Create Your Free Ink Agent Account – Register Now',
        description:
            'Sign up for Ink Agent to start managing, signing & sharing real estate documents effortlessly. Create your agent account in seconds & get productive fast.',
        keywords: 'register, sign up, free account, Ink Agent onboarding',
        canonical: 'https://www.inkagent.ai/register',
    },
    '/doclists': {
        title: 'Organize Your Docs with Ink Agent Document Lists',
        description:
            'Easily view, sort, and manage your document lists and templates in one place. Ink Agent helps agents stay organized, productive, and ready to sign.',
        keywords: 'document list, agent productivity, document manager',
        canonical: 'https://www.inkagent.ai/doclists',
    },
};

const Seo = () => {
    const location = useLocation();
    const pathname = location.pathname;

    const meta = metaMap[pathname] || metaMap['/'];

    return (
        <Helmet>
            <title>{meta.title}</title>
            <meta name="description" content={meta.description} />
            <meta name="keywords" content={meta.keywords} />
            <link rel="canonical" href={meta.canonical} />
        </Helmet>
    );
};

export default Seo;
